module.exports = {"data":{"contentfulProject":{"title":"LOMEPAL — PalPal","youtubeVideoUrl":"https://www.youtube.com/watch?v=0wnWvxO-hE4","production":"Yaka Production ","date":"2017-06-28"}},"pathContext":{"id":"c63hU3cS4UeDSI0PQeI5xFL","previousId":"c7AIUGatM8bi0YOwIZrQ3LT","nextId":"c1AKsYoeJUEyqDwfeH0zfDt"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/projects-c-63-h-u-3-c-s-4-ue-dsi-0-p-qe-i-5-x-fl.json
// module id = ./node_modules/json-loader/index.js!./.cache/json/projects-c-63-h-u-3-c-s-4-ue-dsi-0-p-qe-i-5-x-fl.json
// module chunks = 6007012517858254000